import React from 'react';
import { useSelector } from 'react-redux';
import { supportedMetricsSelector , bleEnabledSelector } from '@store/common/selectors';
import { Retry } from '@components/common';
import { isEmpty } from 'lodash';
import MetricGroup from './MetricGroup';
import { StyledSummary, MetricDivider, ErrorMessage } from './styled';
import { checkAdvancedMetricsEnabled, buildSummary } from '../common/utils';
import { viewerMetricList, viewersMetricCategory } from '../common/mappings';
import useFetchSummaryData from './usefetchSummaryData';
import { CARDINALITY_ERROR } from '../common/constants';

function Summary() {
  const isBusinessMetricEnabled = useSelector(bleEnabledSelector);
  const supportedMetrics = useSelector(supportedMetricsSelector);
  const isAdvancedMetricEnabled = checkAdvancedMetricsEnabled(supportedMetrics);
  const metricsList = viewerMetricList(isBusinessMetricEnabled, isAdvancedMetricEnabled);
  const metricCategories = viewersMetricCategory(isBusinessMetricEnabled, isAdvancedMetricEnabled);
  const { isIdle, status, data, refetch, isError, error } = useFetchSummaryData(metricsList);

  const summary = data ? data.data[0].totals : null;
  const summaryData = React.useMemo(
    () => buildSummary(metricCategories, summary),
    [metricCategories, summary],
  );
  const checkCardinalityError = status === 'error' && isError ? error?.message.includes(500) : null;
  return (
    <StyledSummary>
      {checkCardinalityError ? (
        <ErrorMessage>{CARDINALITY_ERROR}</ErrorMessage>
      ) : (
        <Retry
          isLoading={status === 'loading' || isIdle}
          showError={status === 'error'}
          isEmpty={isEmpty(summaryData)}
          mountChildAlways={false}
          fetchData={refetch}
          horizontal={true}
        >
          <MetricGroup metricGroup={summaryData.PLAY_GROUP} />
          <MetricDivider />
          <MetricGroup metricGroup={summaryData.SPI} />
          <MetricDivider />
          <MetricGroup metricGroup={summaryData.ERROR_GROUP} />
          <MetricDivider />
          <MetricGroup metricGroup={summaryData.QUALITY_GROUP} />
        </Retry>
      )}
    </StyledSummary>
  );
}

export default React.memo(Summary);
